import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { selectDay } from '../../../actions/filterActions';
import { clearReservationError } from '../../../actions/reservationActions';

import './Datebar.css';

class Datebar extends Component {
  // componentWillMount() {
  //   if (!this.props.selectedDay) {
  //     this.props.selectDay(moment().startOf('day'));
  //   }
  // }

  // does day match this.props.selectedDay
  isSelectedDay = (day) => {
    if (this.props.selectedDay) {
      return this.props.selectedDay.date() === day.date();
    }

    return null;
  }

  handleDateClick = (day, event) => {
    event.preventDefault();
    if (!this.isSelectedDay(day)) {
      this.props.selectDay(day);
      this.props.clearReservationError();
    }
  }

  renderDays() {
    // If at least 18 hours left in the day, include today in the Datebar
    // TODO: This 18 threshold should go in a config
    const endOfToday = moment().endOf('day');
    const now = moment();
    const hoursLeftInDay = moment.duration(endOfToday.diff(now)).asHours();
    const dayOffset = hoursLeftInDay >= 18 ? 0 : 1;

    return _.range(8).map(idx => {
      const day = moment()
        .startOf('day')
        .add(idx + dayOffset, 'day');

      const activeDay = this.isSelectedDay(day);

      const linkClasses = classNames('nav-link', { active: activeDay });

      return (
        <li className="nav-item" key={day.format()} role="button">
          <Link className={linkClasses} onClick={this.handleDateClick.bind(this, day)}>
            {day.format('ddd')} <br /> {day.format('M/D')}
          </Link>
        </li>
      );
    });
  }

  render() {
    return (
      <div className="Datebar col">
        <ul className="nav nav-pills nav-justified flex-sm-row">{this.renderDays()}</ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { selectedDay: state.filters.selectedDay };
}

export default connect(
  mapStateToProps,
  { selectDay, clearReservationError }
)(Datebar);



// WEBPACK FOOTER //
// ./src/components/filters/Datebar/Datebar.js